/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Summary_ReviewInputs */



/**
* | output |
* | --- |
* | "Review requested." |
*
* @param {Iconik_Publish_Summary_ReviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_summary_review = /** @type {((inputs?: Iconik_Publish_Summary_ReviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Summary_ReviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Review requested.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Review requested.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Review requested.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Review requested.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Review requested.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Review requested.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Review requested.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Review requested.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Review requested.")
	return /** @type {LocalizedString} */ ("Review requested.")
});